import {
  Award,
  BadgeCheck,
  Briefcase,
  GraduationCap,
  TrendingUp,
  Users,
} from "lucide-react";

const PERFIS = [
  {
    icon: Briefcase,
    title: "Consultor de Investimentos Independente",
    desc: "Atuação com fidúcia e liberdade de escolha para o cliente.",
  },
  {
    icon: Users,
    title: "Assessor Autônomo (AAI)",
    desc: "Sem vínculo de exclusividade com corretoras ou bancos.",
  },
  {
    icon: GraduationCap,
    title: "Educador Financeiro",
    desc: "Orienta e acompanha investidores na prática, com autoridade real.",
  },
  {
    icon: Award,
    title: "Profissional certificado",
    desc: "CEA, CPA-10, CPA-20, CFP® ou equivalente.",
  },
  {
    icon: TrendingUp,
    title: "Busca diversificar a receita",
    desc: "Além de honorários, mentorias ou cursos.",
  },
  {
    icon: BadgeCheck,
    title: "Já tem carteira ativa",
    desc: "Clientes com perfil para diversificação em crédito estruturado.",
  },
];

export const AssessoresParaQuemE = () => {
  return (
    <section id="para-quem-e" className="bg-white py-16 sm:py-20 md:py-24">
      <div className="container-wide px-6 sm:px-6 md:px-12">
        <div className="max-w-2xl">
          <span className="inline-flex items-center rounded-full bg-[#34F285]/[0.06] px-4 py-1.5 text-xs font-medium text-[#1F3D2E] ring-1 ring-[#1F3D2E]/10">
            Para quem é
          </span>
          <h2
            className="mt-6 font-extrabold leading-[1.1] tracking-tight text-[#323F4F] text-3xl sm:text-4xl md:text-5xl"
            style={{ fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif' }}
          >
            Parceria perfeita pra o seu perfil.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed">
            Valorizamos profissionais que priorizam análise isenta,
            transparência e relacionamento de longo prazo com os clientes.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {PERFIS.map((p) => (
            <div
              key={p.title}
              className="bg-[#FAF8F5] rounded-2xl p-6 shadow-[0_8px_30px_-16px_rgba(50,63,79,0.15)] hover:shadow-[0_12px_36px_-16px_rgba(50,63,79,0.22)] transition-shadow"
            >
              <div className="w-10 h-10 rounded-xl bg-[#34F285]/[0.08] flex items-center justify-center">
                <p.icon className="w-5 h-5 text-[#2E694D]" />
              </div>
              <h3
                className="mt-4 text-base font-extrabold text-[#323F4F] tracking-tight"
                style={{ fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif' }}
              >
                {p.title}
              </h3>
              <p className="mt-1.5 text-sm text-zinc-600 leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
